var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "go-icon",
    clipPath: "url(#clip0_3053_9043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.93829 5.99999L2.46798 5.4703L6.96798 0.970301L7.50001 0.43827L8.56173 1.49999L8.03204 2.02968L4.06173 5.99999L8.0297 9.9703L8.56173 10.5L7.50001 11.5617L6.97032 11.032L2.47032 6.53202L1.93829 5.99999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_9043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 12) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow-left-white.80d62c592c6be76beade4ba08dbb5b08.svg";
export { ForwardRef as ReactComponent };